<template>
  <div class="academic-page column-me" :class="{'mobile-mode': isMobile}">
    <!-- Banner -->
    <div class="banner-section column-me center-all">
      <div class="section-content">
        <div class="banner-item">
          <transition name="banner-fade" mode="out-in">
            <img src="../../assets/img/academic/bg_academic.jpg" class="banner-bg" draggable="false">
          </transition>
          <div class="banner-content" v-if="!isMobile">
            <div class="column-me" v-if="$i18n.locale==='zh-cn'||$i18n.locale==='ja'">
              <img src="../../assets/img/home/home_title1.png" class="w500 objScaleDown" draggable="false">
              <img src="../../assets/img/home/home_title2.png" class="w600 objScaleDown mT20" draggable="false">
            </div>
            <div v-else>
              <img src="../../assets/img/home/home_title11.png" class="h300 objContain" draggable="false">
            </div>
          </div>
          <div class="banner-content font-n" v-if="isMobile">
            <img src="../../assets/img/home/home_title_m.png" class="w220 objContain" draggable="false">
            <div class="font36 font-l mT10" v-if="$i18n.locale==='zh-cn'||$i18n.locale==='ja'">
              悦唯所至 繁复皆<span class="colorOrange">简</span>
            </div>
            <img src="../../assets/img/go.png" class="img70 objFitCover mT40" draggable="false">
          </div>
        </div>
      </div>
    </div>
    <div class="column-me row-center">
      <div class="section-content column-me row-center">
        <div class="w100Per row-me row-center color-bars">
          <div class="flex1 h10 color-bar" style="background: #B2C2E3; animation-delay: 0.3s;"></div>
          <div class="flex1 h10 color-bar" style="background: #F7EEF3; animation-delay: 0.45s;"></div>
        </div>
      </div>
    </div>
    <!-- 内容区域 -->
    <div class="content-section column-me center-all pTB80 animate-section" ref="contentSection">
      <div class="section-content row-me pT150 pLR150">
        <!-- 左侧分类 -->
        <div class="category-sidebar column-me animate-slide-left" v-if="!isMobile">
          <div class="category-title">
            <img src="../../assets/img/home/go.png" class="img30" draggable="false">
            <div class="font36 colorBlue mL10 font-db break-word">{{ $t('academic.title') }}</div>
          </div>
          <div class="font16 font-bold mT50 pB20 font-db" style="border-bottom: 1px solid #d1d1d5;">
            {{ $t('common.category') }}
          </div>
          <div class="category-list">
            <div class="category-item row-me row-center flex-sb animate-category-item font-n"
                 v-for="(category, index) in categories"
                 :key="index"
                 :class="{'category-active': currentCategory === index}"
                 :style="{animationDelay: `${0.3 + index * 0.1}s`}"
                 @click="switchCategory(index)">
              <div>{{ category.name || $t(category.nameKey) }}</div>
              <div>（{{ category.articleCount }}）</div>
            </div>
          </div>
        </div>
        <div class="category-sidebar column-me animate-slide-left" v-if="isMobile">
          <div class="category-list posRelative">
            <div class="category-item row-me row-center flex-sb animate-category-item font-n zIndex10"
                 v-for="(category, index) in categories" :key="index"
                 :class="{'category-active': currentCategory === index}"
                 :style="{animationDelay: `${0.3 + index * 0.1}s`}"
                 @click="switchCategory(index)">
              <div>{{ category.name || $t(category.nameKey) }}</div>
              <div>（{{ category.articleCount }}）</div>
            </div>
            <div class="posRT news-text">NEWS</div>
          </div>
          <div></div>
        </div>

        <!-- 右侧文章列表 -->
        <div class="article-content flex1 column-me mL60">
          <!-- 空状态提示 -->
          <div class="empty-state" v-if="hotArticles.length === 0 && articleList.length === 0">
            <div class="empty-icon">
              <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="20" y="15" width="80" height="95" rx="6" stroke="#ABBFCA" stroke-width="3" fill="none"/>
                <line x1="35" y1="40" x2="85" y2="40" stroke="#ABBFCA" stroke-width="3" stroke-linecap="round"/>
                <line x1="35" y1="55" x2="75" y2="55" stroke="#ABBFCA" stroke-width="3" stroke-linecap="round"/>
                <line x1="35" y1="70" x2="65" y2="70" stroke="#ABBFCA" stroke-width="3" stroke-linecap="round"/>
                <circle cx="85" cy="85" r="25" fill="#fff" stroke="#EA8063" stroke-width="3"/>
                <path d="M78 85 L83 90 L93 80" stroke="#EA8063" stroke-width="3" stroke-linecap="round"
                      stroke-linejoin="round" fill="none"/>
              </svg>
            </div>
            <div class="empty-title font-db">{{ $t('common.noData') || '暂无数据' }}</div>
            <div class="empty-desc font-n">{{ $t('common.noDataDesc') || '该分类下暂时没有相关文章' }}</div>
          </div>
          <!-- 热点文章 - PC端 -->
          <div class="hot-articles row-me mB40 animate-section" ref="hotArticlesSection"
               v-show="!isMobile && hotArticles.length > 0">
            <div class="hot-article-card pointer animate-hot-card column-me" v-for="(article, index) in hotArticles"
                 :key="index" :style="{animationDelay: `${index * 0.2}s`}" @click="goToDetail(article)">
              <div class="hot-article-image">
                <img :src="article.image" style="width: 100%; height: 100%; object-fit: cover;" draggable="false">
              </div>
              <div class="flex1 hot-article-info column-me row-center pT20">
                <div class="article-title flex1 font-db">{{ article.title }}</div>
                <div class="w100Per row-me flex-end2">
                  <div class="article-meta alignC mT20 font-n flex1">
                    <div>{{ article.category }}</div>
                    <div class="mT10 alignC">{{ article.date }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 热点文章 - 手机端轮播 -->
          <div class="hot-articles-mobile mB40" v-if="isMobile && hotArticles.length > 0"
               @touchstart="onHotTouchStart" @touchend="onHotTouchEnd">
            <el-carousel ref="hotCarousel" :interval="3000" height="7.7rem" arrow="always" indicator-position="none"
                         :autoplay="hotAutoplay" @change="onHotCarouselChange">
              <el-carousel-item v-for="(article, index) in hotArticles" :key="index">
                <div class="hot-article-card pointer column-me" @click="goToDetail(article)">
                  <div class="hot-article-image">
                    <img :src="article.image" style="width: 100%; height: 100%; object-fit: cover;" draggable="false">
                  </div>
                  <div class="flex1 bgcFA hot-article-info column-me row-center pT20">
                    <div class="article-title flex1 font-db">{{ article.title }}</div>
                    <div class="w100Per row-me row-center flex-end2">
                      <div class="article-meta mT20 font-n flex1">
                        <div>{{ article.category }}</div>
                        <div class="mT10">{{ article.date }}</div>
                      </div>
                      <img src="../../assets/img/academic/rt.png" class="img30 objFitCover" draggable="false">
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>

          <!-- 文章列表 -->
          <div class="article-list animate-section" ref="articleListSection" v-show="articleList.length > 0">
            <div class="article-item row-me pointer mB40 animate-article-item"
                 v-for="(article, index) in articleList" :key="index"
                 :style="{'background':index%2===0?'#f2f4f9':'#f9f5f7', animationDelay: `${index * 0.08}s`}"
                 @click="goToDetail(article)">
              <div class="article-item-content flex1">
                <div class="article-item-title font-db">{{ article.title }}</div>
                <div class="article-item-meta row-me row-center font-n mT20">
                  <div class="" v-if="isMobile">
                    <div>{{ article.category }}</div>
                    <div class="mT10">{{ article.date }}</div>
                  </div>
                  <div class="row-me row-center" v-else>
                    <div>{{ article.category }}</div>
                    <div class="mL50">{{ article.date }}</div>
                  </div>
                  <div class="flex1"></div>
                  <img src="../../assets/img/academic/r.png" class="img50 objFitCover" draggable="false"
                       v-if="isMobile">
                  <img src="../../assets/img/academic/right.png" class="img35 objScaleDown" draggable="false" v-else>
                </div>
              </div>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination-wrapper mB50" v-if="articleList.length > 0">
            <el-pagination
                v-model:current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="prev, pager, next, jumper"
                background
                @current-change="handlePageChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ArrowRight} from "@element-plus/icons";
import {deviceState} from "@/utils/device";
import {getArticleCategories, getArticleList, getArticleRecommend, getImageUrl} from "@/http/api";
import bus from "@/assets/js/bus";

export default {
  components: {
    ArrowRight
  },
  data() {
    return {
      deviceState,
      currentCategory: 0,
      // 资讯类型：1=学术咨询
      articleType: 1,
      // API返回的分类数据
      apiCategories: [],
      // API返回的热点文章
      apiHotArticles: [],
      // API返回的文章列表
      apiArticleList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 热点文章轮播相关
      currentHotIndex: 0,
      hotTouchStartX: 0,
      hotTouchStartY: 0,
      hotAutoplay: true
    }
  },
  computed: {
    isMobile() {
      return this.deviceState.isMobile
    },
    // 分类列表 - 完全从API获取
    categories() {
      if (this.apiCategories && this.apiCategories.length > 0) {
        // 添加"全部"选项
        const allCount = this.apiCategories.reduce((sum, cat) => sum + (cat.articleCount || 0), 0)
        return [
          {id: null, name: this.$t('academic.categories.all'), articleCount: allCount},
          ...this.apiCategories.map(cat => ({
            id: cat.id,
            name: cat.name,
            articleCount: cat.articleCount || 0
          }))
        ]
      }
      return []
    },
    // 热点文章列表 - 完全从API获取
    hotArticles() {
      return this.apiHotArticles || []
    },
    // 文章列表 - 完全从API获取
    articleList() {
      return this.apiArticleList || []
    }
  },
  created() {
    // 路由参数在分类数据加载后处理（见 loadCategoryData 方法）
    // 手机端初始化时检查可见区域
    if (this.isMobile) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkVisibleSections()
        }, 50)
      })
    }
    // 数据加载移到 activated 中，避免首次进入时重复调用
  },
  mounted() {
    this.initScrollAnimation()
    // 确保页面加载时立即检查可见区域
    this.$nextTick(() => {
      this.checkVisibleSections()
    })
    // 监听语言切换事件
    bus.$on('language-changed', this.onLanguageChanged)
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
    bus.$off('language-changed', this.onLanguageChanged)
  },
  activated() {
    // 重新加载数据
    this.loadArticleData()
    this.$nextTick(() => {
      this.resetAnimations()
      // 重新检查可见区域
      setTimeout(() => {
        this.checkVisibleSections()
      }, 100)
    })
  },
  methods: {
    // 语言切换时重新加载数据
    onLanguageChanged() {
      this.loadArticleData()
    },
    // 加载学术咨询数据
    async loadArticleData() {
      try {
        // 先加载分类数据
        const catRes = await getArticleCategories(this.articleType)
        // 处理分类数据
        if (catRes && catRes.code === 200 && catRes.data) {
          this.apiCategories = catRes.data
          // 分类数据加载完成后，根据路由参数设置当前分类
          this.initCategoryFromRoute()
        }
        // 加载推荐文章
        const recommendRes = await getArticleRecommend(this.articleType, this.getCurrentCategoryId())
        // 处理推荐文章数据
        if (recommendRes && recommendRes.code === 200 && recommendRes.data) {
          this.apiHotArticles = recommendRes.data.map((item) => ({
            id: item.id,
            title: item.title,
            category: item.tags ? item.tags.replaceAll(',', ' | ') : '',
            date: item.publishTime ? item.publishTime.split(' ')[0].replace(/-/g, '/') : '',
            image: getImageUrl(item.coverImage)
          }))
        }
        // 加载文章列表
        await this.loadArticleList()
      } catch (error) {
        console.error('加载学术咨询数据失败:', error)
      }
    },
    // 根据路由参数初始化当前分类
    initCategoryFromRoute() {
      const categoryId = this.$route.query.categoryId
      if (categoryId !== undefined && categoryId !== null) {
        // 根据categoryId找到对应的分类索引
        const catId = parseInt(categoryId, 10)
        const index = this.apiCategories.findIndex(cat => cat.id === catId)
        if (index >= 0) {
          // currentCategory: 0=全部, 1+=具体分类
          this.currentCategory = index + 1
        } else {
          this.currentCategory = 0
        }
      } else {
        // 没有categoryId参数，显示"全部"
        this.currentCategory = 0
      }
    },
    // 加载分类内容（推荐文章和文章列表，不重新加载分类数据）
    async loadCategoryContent() {
      try {
        const recommendRes = await getArticleRecommend(this.articleType, this.getCurrentCategoryId())
        if (recommendRes && recommendRes.code === 200 && recommendRes.data) {
          this.apiHotArticles = recommendRes.data.map((item) => ({
            id: item.id,
            title: item.title,
            category: item.tags ? item.tags.replaceAll(',', ' | ') : '',
            date: item.publishTime ? item.publishTime.split(' ')[0].replace(/-/g, '/') : '',
            image: getImageUrl(item.coverImage)
          }))
        }
        await this.loadArticleList()
      } catch (error) {
        console.error('加载分类内容失败:', error)
      }
    },
    // 获取当前选中分类的ID
    getCurrentCategoryId() {
      if (this.currentCategory === 0) return undefined
      if (this.apiCategories && this.apiCategories.length > 0) {
        const index = this.currentCategory - 1
        if (index >= 0 && index < this.apiCategories.length) {
          return this.apiCategories[index].id
        }
      }
      return undefined
    },
    // 加载文章列表
    async loadArticleList() {
      try {
        const params = {
          type: this.articleType,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        const categoryId = this.getCurrentCategoryId()
        if (categoryId) {
          params.categoryId = categoryId
        }
        const res = await getArticleList(params)
        if (res && res.code === 200 && res.data) {
          this.total = res.data.total || 0
          this.apiArticleList = (res.data.list || []).map(item => ({
            id: item.id,
            title: item.title,
            category: item.tags ? item.tags.replaceAll(',', ' | ') : '',
            date: item.publishTime ? item.publishTime.split(' ')[0].replace(/-/g, '/') : ''
          }))
        }
      } catch (error) {
        console.error('加载文章列表失败:', error)
      }
    },
    // 重置所有动画
    resetAnimations() {
      const sections = [
        this.$refs.contentSection,
        this.$refs.hotArticlesSection,
        this.$refs.articleListSection
      ]

      sections.forEach(section => {
        if (section) {
          section.classList.remove('animate-in')
        }
      })

      this.$nextTick(() => {
        // 重置 banner 动画
        const bannerContent = document.querySelector('.banner-content')
        if (bannerContent) {
          bannerContent.style.animation = 'none'
          setTimeout(() => {
            bannerContent.style.animation = ''
          }, 10)
        }

        // 重置彩色条动画
        const colorBars = document.querySelectorAll('.color-bar')
        colorBars.forEach(bar => {
          bar.style.animation = 'none'
          setTimeout(() => {
            bar.style.animation = ''
          }, 10)
        })

        // 重置分类项动画
        const categoryItems = document.querySelectorAll('.animate-category-item')
        categoryItems.forEach(item => {
          item.style.animation = 'none'
          setTimeout(() => {
            item.style.animation = ''
          }, 10)
        })

        // 重置热点卡片动画
        const hotCards = document.querySelectorAll('.animate-hot-card')
        hotCards.forEach(card => {
          card.style.animation = 'none'
          setTimeout(() => {
            card.style.animation = ''
          }, 10)
        })

        // 重置文章列表动画
        const articleItems = document.querySelectorAll('.animate-article-item')
        articleItems.forEach(item => {
          item.style.animation = 'none'
          setTimeout(() => {
            item.style.animation = ''
          }, 10)
        })
      })
    },
    // 初始化滚动动画
    initScrollAnimation() {
      const options = {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      }, options)

      const sections = [
        this.$refs.contentSection,
        this.$refs.hotArticlesSection,
        this.$refs.articleListSection
      ]

      sections.forEach(section => {
        if (section) {
          this.observer.observe(section)
        }
      })
    },
    // 检查当前视口中可见的区块，立即触发它们的动画
    checkVisibleSections() {
      const sections = [
        this.$refs.contentSection,
        this.$refs.hotArticlesSection,
        this.$refs.articleListSection
      ]

      // 手机端直接触发所有动画，确保内容可见
      if (this.isMobile) {
        sections.forEach(section => {
          if (section) {
            section.classList.add('animate-in')
          }
        })
        return
      }

      sections.forEach(section => {
        if (section) {
          const rect = section.getBoundingClientRect()
          const windowHeight = window.innerHeight || document.documentElement.clientHeight
          const threshold = 0.85

          if (rect.top < windowHeight * threshold && rect.bottom > 0) {
            section.classList.add('animate-in')
          }
        }
      })
    },
    // 切换分类
    switchCategory(index) {
      this.currentCategory = index
      this.currentPage = 1 // 重置页码
      // 重新加载推荐文章和文章列表
      this.loadCategoryContent()
      // 更新URL参数（全部分类不需要参数，其他分类用categoryId）
      if (index === 0) {
        // 全部分类，清除categoryId参数
        this.$router.push({
          path: '/academic',
          query: {}
        })
      } else {
        // 具体分类，使用分类ID
        const categoryId = this.getCurrentCategoryId()
        this.$router.push({
          path: '/academic',
          query: {categoryId: categoryId}
        })
      }

      // 手机端点击分类后，滚动到内容区域顶部
      if (this.isMobile) {
        this.$nextTick(() => {
          const contentSection = this.$refs.contentSection
          const scrollContainer = document.getElementById('content')
          if (contentSection && scrollContainer) {
            // 计算 contentSection 相对于滚动容器的位置
            const containerRect = scrollContainer.getBoundingClientRect()
            const sectionRect = contentSection.getBoundingClientRect()
            const scrollTop = scrollContainer.scrollTop + sectionRect.top - containerRect.top - 150
            scrollContainer.scrollTo({
              top: scrollTop,
              behavior: 'smooth'
            })
          }
        })
      }
    },
    goToDetail(article) {
      this.$router.push({
        path: '/articleDetail',
        query: {id: article.id}
      })
    },
    handlePageChange(page) {
      this.currentPage = page
      // 重新加载文章列表
      this.loadArticleList()
    },
    // 热点文章轮播切换
    onHotCarouselChange(index) {
      this.currentHotIndex = index
    },
    // 点击指示器切换
    switchHotCarousel(index) {
      this.$refs.hotCarousel.setActiveItem(index)
    },
    // 触摸开始
    onHotTouchStart(e) {
      this.hotTouchStartX = e.touches[0].clientX
      this.hotTouchStartY = e.touches[0].clientY
    },
    // 触摸结束
    onHotTouchEnd(e) {
      const touchEndX = e.changedTouches[0].clientX
      const touchEndY = e.changedTouches[0].clientY
      const deltaX = touchEndX - this.hotTouchStartX
      const deltaY = touchEndY - this.hotTouchStartY

      // 判断是否为水平滑动
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        const total = this.hotArticles.length
        let newIndex
        if (deltaX > 0) {
          // 向右滑动，上一张
          newIndex = (this.currentHotIndex - 1 + total) % total
        } else {
          // 向左滑动，下一张
          newIndex = (this.currentHotIndex + 1) % total
        }
        this.$refs.hotCarousel.setActiveItem(newIndex)
        // 重启自动播放
        this.restartHotAutoplay()
      }
    },
    // 重启自动播放
    restartHotAutoplay() {
      this.hotAutoplay = false
      this.$nextTick(() => {
        this.hotAutoplay = true
      })
    }
  },
  watch: {
    '$route.query.categoryId': {
      handler(newCategoryId, oldCategoryId) {
        // 当查询参数变化时（同页面内切换分类）
        let categoryChanged = false
        if (this.apiCategories && this.apiCategories.length > 0) {
          if (newCategoryId !== undefined && newCategoryId !== null) {
            const catId = parseInt(newCategoryId, 10)
            const index = this.apiCategories.findIndex(cat => cat.id === catId)
            if (index >= 0) {
              if (this.currentCategory !== index + 1) {
                this.currentCategory = index + 1
                categoryChanged = true
              }
            } else {
              if (this.currentCategory !== 0) {
                this.currentCategory = 0
                categoryChanged = true
              }
            }
          } else {
            // 没有categoryId参数，显示全部
            if (this.currentCategory !== 0) {
              this.currentCategory = 0
              categoryChanged = true
            }
          }
          // 当从header/footer切换分类时，重新加载分类内容
          if (categoryChanged) {
            this.currentPage = 1
            this.loadCategoryContent()
          }
        }

        // PC端：同页面内切换分类时，滚动到内容区顶部
        // 手机端的滚动已在 switchCategory 中处理
        if (!this.isMobile && categoryChanged) {
          const contentSection = this.$refs.contentSection
          if (contentSection) {
            contentSection.scrollIntoView({behavior: 'smooth', block: 'start'})
          }
        }
      },
      immediate: false
    },
    $route: {
      handler(to, from) {
        // 只有从其他页面进入学术资讯页面时才重置动画和滚动
        if (to.path === '/academic' && from && from.path !== '/academic') {
          setTimeout(() => {
            this.resetAnimations()
            window.scrollTo({top: 0, behavior: 'smooth'})
          }, 50)
        }
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
.academic-page {
  width: 100%;
  scroll-behavior: smooth;
  overflow: hidden;

  .news-text {
    color: #f9fafc;
    font-size: 120px;
    line-height: 60px;
  }
}

// Banner 进入动画
.banner-section {
  .banner-content {
    animation: fadeInUp 1.2s ease-out 0.3s both;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 彩色条展开动画
.color-bars {
  .color-bar {
    opacity: 0;
    transform: scaleX(0);
    transform-origin: left;
    animation: barExpand 0.8s ease-out forwards;
  }
}

@keyframes barExpand {
  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

// 滚动触发动画
.animate-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
}

// 左侧滑入动画
.animate-slide-left {
  opacity: 0;
  transform: translateX(-60px);
  transition: all 0.8s ease-out 0.2s;
}

.animate-section.animate-in {
  .animate-slide-left {
    opacity: 1;
    transform: translateX(0);
  }
}

// 分类项动画
.animate-category-item {
  opacity: 0;
  transform: translateX(-20px);
  animation: slideInLeft 0.5s ease-out forwards;
}

@keyframes slideInLeft {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

// 热点卡片动画
.animate-hot-card {
  opacity: 0;
  transform: translateY(30px) scale(0.95);
  animation: hotCardFadeIn 0.8s ease-out forwards;
}

@keyframes hotCardFadeIn {
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

// 文章列表项动画
.animate-article-item {
  opacity: 0;
  transform: translateX(30px);
  animation: articleSlideIn 0.6s ease-out forwards;
}

@keyframes articleSlideIn {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

// 左侧分类栏
.category-sidebar {
  width: 280px;
  flex-shrink: 0;

  .category-title {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: #013D5C;

    .icon {
      width: 18px;
      height: 18px;
    }
  }

  .category-list {
    .category-item {
      padding: 15px 0;
      font-size: 18px;
      color: #2C2B30;
      cursor: pointer;
      margin-bottom: 10px;
      transition: all 0.3s;
      border-bottom: 1px solid #d1d1d5;

      &:hover {
        background: #F8F9FA;
        color: #EA8063;
      }
    }

    .category-active {
      color: #EA8063;
    }
  }
}

// 空状态样式
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 40px;
  min-height: 400px;
  background: linear-gradient(135deg, #f8f9fc 0%, #fff 100%);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  animation: emptyFadeIn 0.6s ease-out;

  .empty-icon {
    width: 120px;
    height: 120px;
    margin-bottom: 30px;
    opacity: 0.9;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .empty-title {
    font-size: 24px;
    color: #2C2B30;
    margin-bottom: 12px;
    text-align: center;
  }

  .empty-desc {
    font-size: 16px;
    color: #ABBFCA;
    text-align: center;
    max-width: 280px;
    line-height: 1.6;
  }
}

@keyframes emptyFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 右侧文章区域
.article-content {
  // 热点文章
  .hot-articles {
    gap: 30px;

    .hot-article-card {
      flex: 1;
      background: #FFFFFF;
      overflow: hidden;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(90deg, #EA8063, #FF8C4D);
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      }

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 12px 30px rgba(234, 128, 99, 0.2);

        &::before {
          transform: scaleX(1);
        }

        .hot-article-image img {
          transform: scale(1.1);
        }

        .article-title {
          color: #EA8063;
        }

        .article-meta {
          color: #EA8063;
        }
      }

      .hot-article-image {
        width: 100%;
        height: 360px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }
      }

      .hot-article-info {
        padding: 50px 20px;

        .article-title {
          font-size: 34px;
          color: #2C2B30;
          line-height: 1.5;
          text-align: center;
          transition: color 0.3s ease;
        }

        .article-meta {
          font-size: 24px;
          color: #ABBFCA;
          transition: color 0.3s ease;
        }
      }
    }
  }

  // 文章列表
  .article-list {
    .article-item {
      padding: 25px 50px;
      border-left: 12px solid transparent;
      border-radius: 4px;
      position: relative;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      overflow: hidden;

      &:hover {
        border-left: 12px solid #EA8063;
        padding-left: 60px;
        transform: translateX(5px);
        box-shadow: 0 4px 15px rgba(234, 128, 99, 0.1);

        &::before {
          width: 100%;
        }

        &::after {
          opacity: 1;
          transform: translateY(-50%) translateX(0);
        }

        .article-item-title {
          color: #EA8063;
          transform: translateX(5px);
        }

        .article-item-meta {
          color: #EA8063;
        }

        img {
          transform: translateX(5px);
        }
      }

      .article-item-content {
        position: relative;
        z-index: 1;

        .article-item-title {
          font-size: 34px;
          color: #2C2B30;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .article-item-meta {
          font-size: 24px;
          color: #ABBFCA;
          transition: color 0.3s ease;

          .meta-divider {
            width: 1px;
            height: 12px;
            background: #CCCCCC;
            margin: 0 15px;
          }

          img {
            transition: transform 0.3s ease;
          }
        }
      }
    }
  }

  // 分页
  .pagination-wrapper {
    display: flex;
    justify-content: center;
  }
}

// ==================== 手机端适配样式 ====================
.academic-page.mobile-mode {
  // Banner 适配 - 与首页保持一致
  .banner-section {
    .section-content {
      width: 100% !important;
      padding: 0 !important;
    }

    .banner-item {
      position: relative;
      width: 100%;
      height: 1020px;
      aspect-ratio: 16 / 9;
      overflow: hidden;
      background: #f5f5f5;

      .banner-bg {
        position: absolute;
        top: inherit;
        left: inherit;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 65%;
        object-fit: cover;
        object-position: right;
      }

      .banner-content {
        position: absolute;
        top: 25%;
        left: 8%;
        display: flex;
        flex-direction: column;
        font-size: 87px;
        line-height: 80px;
        color: #454F5E;
      }
    }
  }

  // 彩色条适配
  .color-bars {
    .color-bar {
      height: 6px !important;
    }
  }

  // 内容区域
  .content-section {
    padding: 30px 0 !important;

    .section-content {
      width: 100%;
      flex-direction: column !important;
      padding: 0 !important;

      .pT150 {
        padding-top: 20px !important;
      }

      .pLR150 {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    }

    // 左侧分类栏改为顶部Tab
    .category-sidebar {
      width: 100% !important;
      margin-bottom: 20px;
      // 手机端直接显示，不需要动画
      opacity: 1 !important;
      transform: none !important;
      padding-left: 60px;
      padding-right: 60px;

      .category-title {
        .img30 {
          width: 40px !important;
          height: 40px !important;
          object-fit: cover !important;
        }
      }

      .font16 {
        font-size: 25px !important;
        margin-top: 20px !important;
      }

      .category-list {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        padding-top: 50px;
        margin-bottom: 20px;
        border-bottom: 2px solid #D9DBE1;

        .category-item {
          padding-bottom: 24px;
          margin-right: 30px;
          font-size: 26px !important;
          color: #454F5E !important;
          margin-bottom: 0 !important;
          flex: none;
          width: auto;
          // 手机端直接显示，不需要动画
          opacity: 1 !important;
          transform: none !important;
          animation: none !important;
          border-bottom: 5px solid transparent;

          &.category-active {
            font-family: font-db, serif;
            border-bottom: 5px solid #EA8063;
          }

          div:last-child {
            display: none;
          }

          &:hover {
            background: none;
          }
        }
      }
    }

    // 文章内容区域
    .article-content {
      margin-left: 0 !important;
      width: 100%;

      // 热点文章轮播 - 手机端
      .hot-articles-mobile {
        width: 100%;

        :deep(.el-carousel__arrow) {
          width: 50px !important;
          height: 50px !important;
          background: #959595 !important;
          top: 30% !important;

          .el-icon {
            font-size: 30px !important;
          }
        }

        .hot-article-card {
          width: 100%;
          height: 100%;
          background: #fff;

          .hot-article-image {
            height: 330px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .hot-article-info {
            padding: 28px 60px;
            align-items: flex-start;

            .article-title {
              font-size: 34px;
              color: #454F5E;
              line-height: 1.5;
              text-align: left;
            }

            .article-meta {
              font-size: 20px;
              color: #454F5E;
              text-align: left;
            }
          }
        }

        .hot-carousel-dots {
          gap: 15px;

          .dot {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 2px solid #EA8063;
            background: transparent;
            transition: all 0.3s ease;
            cursor: pointer;

            &.dot-active {
              background: #EA8063;
            }
          }
        }
      }

      // 文章列表
      .article-list {
        .article-item {
          padding: 25px 60px !important;
          margin-bottom: 20px !important;
          border-left-width: 6px !important;

          &:hover {
            padding-left: 40px !important;
            border-left-width: 6px !important;
          }

          .article-item-content {
            .article-item-title {
              font-size: 34px !important;
              line-height: 1.5;
            }

            .article-item-meta {
              font-size: 20px !important;
              margin-top: 50px !important;
              color: #454F5E !important;

              .mL50 {
                margin-left: 15px !important;
              }

              .img35 {
                width: 25px !important;
                height: 25px !important;
              }
            }
          }
        }
      }

      // 分页
      .pagination-wrapper {
        margin-bottom: 30px !important;

        :deep(.el-pagination) {
          .btn-prev, .btn-next, .el-pager li {
            min-width: 40px;
            height: 40px;
            line-height: 40px;
            font-size: 25px !important;
          }

          .el-pagination__goto, .el-pagination__classifier {
            font-size: 25px !important;
          }

          .el-input__inner {
            font-size: 25px !important;
          }
        }
      }

      // 手机端空状态样式
      .empty-state {
        padding: 60px 40px;
        min-height: 300px;
        margin: 0 60px;

        .empty-icon {
          width: 160px;
          height: 160px;
        }

        .empty-title {
          font-size: 32px;
        }

        .empty-desc {
          font-size: 24px;
          max-width: 400px;
        }
      }
    }
  }
}
</style>

